var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCostOptimisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_213_27)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1437 36.238C60.1629 37.9382 57.3061 38.1147 55.1825 36.5911C54.6683 36.2287 54.3064 36.2008 53.7731 36.4888C52.4971 37.1578 51.202 37.7988 49.8974 38.4027C49.4022 38.635 49.2308 38.9137 49.2117 39.4525C49.0784 42.4348 46.7263 44.6831 43.7361 44.7389C40.765 44.7946 38.2986 42.602 38.0796 39.6383C38.0319 38.9694 38.27 38.2726 38.3176 37.5944C38.3367 37.3343 38.2891 36.9348 38.1177 36.8047C36.6131 35.6899 35.0704 34.6214 33.5277 33.5345C32.0992 34.5657 30.5851 35.0581 28.8329 34.7608C25.738 34.2126 23.7192 31.3233 24.3382 28.2574C24.9381 25.2845 28.0997 23.352 31.147 24.086C34.2038 24.8199 36.0893 27.923 35.1751 30.8402C34.9561 31.537 35.1085 31.8529 35.6798 32.2338C36.9273 33.0514 38.1177 33.9711 39.3651 34.798C39.5937 34.9466 40.0508 35.0117 40.2698 34.8909C43.4504 33.0792 46.0121 33.5251 48.3832 36.3309C48.4213 36.3773 48.4785 36.396 48.6023 36.4796C49.3165 36.1265 50.0783 35.7641 50.8401 35.3833C51.6019 35.0024 52.3638 34.6214 53.1256 34.2405C53.0304 33.5995 52.8875 33.0142 52.8589 32.4103C52.7256 29.8647 54.3826 27.6071 56.849 26.9289C59.363 26.2321 62.077 27.3191 63.3055 29.5209C64.5625 31.76 64.0768 34.575 62.1437 36.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4222 50.4478C34.4222 53.2443 34.4317 56.0408 34.4222 58.8465C34.4126 60.9834 33.0795 62.2933 30.8892 62.3212C29.7655 62.3397 28.6418 62.3305 27.5182 62.3212C25.366 62.2933 24.0138 60.9647 24.0042 58.8093C23.9947 54.545 24.0042 50.2714 24.0042 45.9977C24.0042 44.6691 23.9947 43.3406 24.0042 42.0213C24.0233 39.8381 25.3755 38.5189 27.5943 38.491C28.6895 38.4817 29.7846 38.4723 30.8797 38.491C33.0699 38.5281 34.4126 39.8381 34.4222 41.9656C34.4317 44.7899 34.4222 47.6236 34.4222 50.4478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.802 55.0161C48.802 56.3168 48.8115 57.6082 48.802 58.9089C48.7829 60.9064 47.4117 62.2628 45.3452 62.2907C44.1644 62.3092 42.9836 62.3092 41.8027 62.2907C39.8506 62.2628 38.4221 60.9435 38.3936 59.039C38.346 56.3354 38.3555 53.6226 38.3936 50.9097C38.4221 48.968 39.8601 47.6302 41.8503 47.6023C43.0312 47.5837 44.212 47.5837 45.3928 47.6023C47.3831 47.6395 48.7734 49.0145 48.802 50.9561C48.8115 52.3033 48.802 53.6597 48.802 55.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1698 52.4213C63.1698 54.5303 63.1794 56.6299 63.1698 58.7388C63.1603 60.9035 61.7795 62.2414 59.5607 62.2506C58.437 62.2599 57.3133 62.2692 56.1896 62.2506C54.1898 62.2135 52.7614 60.8663 52.7519 58.9153C52.7233 54.5581 52.7233 50.2008 52.7519 45.8529C52.7614 43.9483 54.1898 42.6012 56.1325 42.564C57.3419 42.5361 58.5608 42.5454 59.7702 42.564C61.7033 42.5919 63.1317 43.9668 63.1603 45.8529C63.1889 48.0361 63.1698 50.2287 63.1698 52.4213Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_27",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(24 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCostOptimisation);
export default __webpack_public_path__ + "static/media/cloud-cost-optimisation.e77c0ddd02fddbba65ab77b9741b174c.svg";
export { ForwardRef as ReactComponent };